import React, { useState, useRef, useEffect } from "react";
import { Card, Form, InputGroup, Badge } from "react-bootstrap";
import { FaHeart, } from "react-icons/fa";
import { IoClose, IoSend } from "react-icons/io5";
import { BsChatHeartFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sendChatMessage } from "../../store/slices/chatbot";

const BOT_AVATAR = "🤖";


function getTime() {
    return new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
}

export default function FloatingChatBot() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [unread, setUnread] = useState(0);

    const [messages, setMessages] = useState([
        {
            id: Date.now(),
            type: "bot",
            text: (
                <>
                    Hi! I'm <strong>Kalyani</strong>, your{" "}
                    <strong>KVL Matrimony</strong> assistant{" "}
                    <FaHeart color="#dc3545" />
                    <br />
                    How can I help you today?
                </>
            ),
            time: getTime(),
        },
    ]);

    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({
            behavior: "smooth",
        });
    }, [messages, isTyping]);

    useEffect(() => {
        if (open) {
            setUnread(0);

            setTimeout(() => {
                inputRef.current?.focus();
            }, 250);
        }
    }, [open]);

    const addBotMessage = (response) => {
        setMessages((prev) => [
            ...prev,
            {
                id: Date.now(),
                type: "bot",

                text: response.message || "",

                responseType: response.responseType || "text",

                data: response.data || {},
                action: response.action || "",
                link: response.link || "",

                buttonText: response.buttonText || "",

                time: getTime(),
            },
        ]);

        if (!open) {
            setUnread((u) => u + 1);
        }
    };

    const send = async (text) => {
        if (!text.trim()) return;

        setMessages((prev) => [
            ...prev,
            {
                id: Date.now(),
                type: "user",
                text,
                seen: false,
                time: getTime(),
            },
        ]);

        setMessage("");
        setIsTyping(true);

        try {
            const result = await dispatch(
                sendChatMessage({
                    message: text,
                })
            );

            setIsTyping(false);

            if (sendChatMessage.fulfilled.match(result)) {
                addBotMessage(result.payload);
            } else {
                addBotMessage({
                    message: "Sorry, something went wrong.",
                });
            }
        } catch (e) {
            setIsTyping(false);

            addBotMessage({
                message: e.message || "Something went wrong.",
            });
        }
    };

    const sendMessage = () => {

        send(message);
    };


    const renderResponse = (item) => {
        switch (item.responseType) {
            case "profiles":
                return renderProfiles(item);

            case "plans":
                return renderMembership(item);

            case "payment":
                return renderPayments(item);

            case "user":
                return renderUser(item);

            case "contacts":
                return renderContacts(item);

            // case "faq":
            //     return renderFaq(item);

            // case "custom":
            //     return renderCustom(item);

            default:
                return null;
        }
    };

    const renderProfiles = (item) => {

        // Show message if no profiles found
        if (!item.data?.profiles?.length) {
            return (
                <Card
                    className="border-0 shadow-sm mt-2"
                    style={{ borderRadius: 16 }}
                >
                    <Card.Body className="text-center py-4">
                        <div style={{ fontSize: 40 }}>🔍</div>

                        <h6
                            className="mt-3 mb-2"
                            style={{ color: "#d81b60", fontWeight: 600 }}
                        >
                            {item.text || item.message || "No matching profiles found."}
                        </h6>

                        <small className="text-muted">
                            Try changing your search criteria.
                        </small>
                    </Card.Body>
                </Card>
            );
        }

        return (
            <div className="d-flex flex-column gap-3 mt-3">
                {item.data.profiles.map((profile) => (
                    <Card
                        key={profile._id}
                        className="shadow-sm border-0"
                        style={{
                            borderRadius: 18,
                        }}
                    >
                        <Card.Body>

                            <div className="d-flex">

                                <img
                                    src={
                                        profile.profilePhoto ||
                                        "/images/user.png"
                                    }
                                    alt=""
                                    style={{
                                        width: 80,
                                        height: 95,
                                        objectFit: "cover",
                                        borderRadius: 12,
                                    }}
                                />

                                <div className="ms-3 flex-grow-1">

                                    <h6
                                        style={{
                                            color: "#d81b60",
                                            fontWeight: 700,
                                        }}
                                    >
                                        {profile.name}
                                    </h6>

                                    <div>{profile.age} Years</div>

                                    <div>{profile.city}</div>

                                    <div>{profile.occupation}</div>

                                    <button
                                        className="btn btn-sm mt-2"
                                        style={{
                                            background: "#d81b60",
                                            color: "#fff",
                                        }}
                                        onClick={() =>
                                            navigate(`/profile/${profile._id}`)
                                        }
                                    >
                                        View Profile
                                    </button>

                                </div>

                            </div>

                        </Card.Body>
                    </Card>
                ))}
            </div>
        );
    };

    const renderMembership = (item) => {
        const plans = item.data?.data || [];

        if (!plans.length) return null;

        return (
            <div className="d-flex flex-column gap-2 mt-3">
                {plans.map((plan) => (
                    <Card
                        key={plan._id}
                        className="shadow-sm border-0"
                        style={{ borderRadius: 16 }}
                    >
                        <Card.Body>
                            <h5
                                style={{
                                    color: "#D4AF37",
                                    fontWeight: 700,
                                }}
                            >
                                💎 {plan.name}
                            </h5>

                            <hr />

                            <div>
                                <strong>Price:</strong> ₹{plan.price}
                            </div>

                            <div>
                                <strong>Duration:</strong>{" "}
                                {plan.duration} {plan.durationType}
                            </div>

                            <div>
                                <strong>Contact Views:</strong>{" "}
                                {plan.limits.contactViews === -1
                                    ? "Unlimited"
                                    : plan.limits.contactViews}
                            </div>

                            <div>
                                <strong>Chats:</strong>{" "}
                                {plan.limits.chats === -1
                                    ? "Unlimited"
                                    : plan.limits.chats}
                            </div>

                            <div className="mt-2">
                                {plan.features.verifiedBadge && (
                                    <Badge bg="success" className="me-2">
                                        Verified Badge
                                    </Badge>
                                )}

                                {plan.features.profileHighlight && (
                                    <Badge bg="warning" text="dark">
                                        Profile Highlight
                                    </Badge>
                                )}
                            </div>

                            <button
                                className="btn btn-sm mt-3"
                                style={{
                                    background: "#d81b60",
                                    color: "#fff",
                                    borderRadius: 20,
                                }}
                            >
                                Buy Now
                            </button>
                        </Card.Body>
                    </Card>
                ))}
            </div>
        );
    };

    const renderPayments = (item) => {
        if (!item.data?.payments?.length) return null;

        return item.data.payments.map((payment) => (
            <Card
                key={payment._id}
                className="mt-2 shadow-sm border-0"
            >

                <Card.Body>

                    <div
                        className="d-flex justify-content-between"
                    >

                        <strong>
                            ₹{payment.amount}
                        </strong>

                        <Badge
                            bg={
                                payment.status === "SUCCESS"
                                    ? "success"
                                    : "danger"
                            }
                        >
                            {payment.status}
                        </Badge>

                    </div>

                    <div className="mt-2">
                        {payment.planName}
                    </div>

                    <small>
                        {payment.createdAt}
                    </small>

                </Card.Body>

            </Card>
        ));
    };

    const renderUser = (item) => {
        if (!item.data?.user) return null;

        const user = item.data.user;

        return (
            <Card
                className="shadow-sm mt-3 border-0"
            >

                <Card.Body>

                    <div
                        className="text-center"
                    >

                        <img
                            src={
                                user.profilePhoto ||
                                "/images/user.png"
                            }
                            alt=""
                            style={{
                                width: 70,
                                height: 70,
                                borderRadius: "50%",
                            }}
                        />

                        <h6 className="mt-2">

                            {user.name}

                        </h6>

                    </div>

                    <hr />

                    <div>{user.email}</div>

                    <div>{user.mobile}</div>

                    <div>{user.city}</div>

                </Card.Body>

            </Card>
        );
    };

    const renderContacts = (item) => {
        if (!item.data?.contacts) return null;

        const contact = item.data.contacts;

        return (
            <Card
                className="mt-3 shadow-sm border-0"
            >

                <Card.Body>

                    <div
                        className="d-flex justify-content-between"
                    >
                        <span>Total</span>

                        <strong>
                            {contact.total}
                        </strong>
                    </div>

                    <div
                        className="d-flex justify-content-between mt-2"
                    >
                        <span>Used</span>

                        <Badge bg="danger">
                            {contact.used}
                        </Badge>
                    </div>

                    <div
                        className="d-flex justify-content-between mt-2"
                    >
                        <span>Remaining</span>

                        <Badge bg="success">
                            {contact.remaining}
                        </Badge>
                    </div>

                </Card.Body>

            </Card>
        );
    };

    const renderFaq = (item) => {
        return (
            <Card
                className="mt-3 border-0 bg-light"
            >
                <Card.Body>
                    {item.text}
                </Card.Body>
            </Card>
        );
    };

    const renderCustom = (item) => {
        return (
            <Card
                className="mt-3 border-0"
            >
                <Card.Body>
                    {item.text}
                </Card.Body>
            </Card>
        );
    };
    return (
        <>
            <style>{`
                @keyframes kvl-pop-in {
                    from { opacity: 0; transform: translateY(24px) scale(0.96); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }
                @keyframes kvl-msg-in {
                    from { opacity: 0; transform: translateY(10px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                @keyframes kvl-pulse-ring {
                    0%   { box-shadow: 0 0 0 0 rgba(216,27,96,0.45); }
                    70%  { box-shadow: 0 0 0 12px rgba(216,27,96,0); }
                    100% { box-shadow: 0 0 0 0 rgba(216,27,96,0); }
                }
                @keyframes kvl-dot-bounce {
                    0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
                    30% { transform: translateY(-5px); opacity: 1; }
                }
                @keyframes kvl-status-blink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }
                .kvl-scrollbar::-webkit-scrollbar { width: 5px; }
                .kvl-scrollbar::-webkit-scrollbar-thumb { background: #f3a9c4; border-radius: 10px; }
                .kvl-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .kvl-quick-chip:hover {
                    background: #d81b60 !important;
                    color: #fff !important;
                    transform: translateY(-1px);
                }
                .kvl-send-btn:hover { filter: brightness(1.08); }
                .kvl-send-btn:disabled { opacity: 0.6; filter: none; }
                .kvl-input:focus {
                    box-shadow: 0 0 0 3px rgba(216,27,96,0.15) !important;
                    border-color: #d81b60 !important;
                }
                .kvl-fab {
                    position: fixed;
                    bottom: 70px;
                    right: 70px;
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    background: linear-gradient(135deg,#c2185b,#e91e63);
                    border: none;
                    font-size: 24px;
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 18px rgba(216,27,96,0.4);
                    animation: kvl-pulse-ring 2.2s infinite;
                    padding: 0;
                }
                .kvl-chat-card {
                    position: fixed;
                    bottom: 16px;
                    right: 16px;
                    width: 330px;
                    height: 480px;
                    max-height: calc(100vh - 32px);
                    border-radius: 20px;
                    overflow: hidden;
                    z-index: 9999;
                    animation: kvl-pop-in 0.28s ease-out;
                    font-family: 'Segoe UI', system-ui, sans-serif;
                    display: flex;
                    flex-direction: column;
                }
                .kvl-messages {
                    flex: 1 1 auto;
                    overflow-y: auto;
                    background: linear-gradient(180deg,#fff5f8 0%,#fdf7f9 100%);
                    min-height: 0;
                }
                @media (max-width: 480px) {
                    .kvl-fab {
                        width: 50px;
                        height: 50px;
                        font-size: 21px;
                        bottom: 14px;
                        right: 14px;
                    }
                    .kvl-chat-card {
                         .kvl-chat-card {
        left: 10px;
        right: 10px;
        bottom: 10px;
        top: auto;

        width: calc(100vw - 20px);
        height: 70dvh;
        max-height: 70dvh;

        border-radius: 18px;
    }
                    }
                }
                @media (min-width: 481px) and (max-width: 768px) {
                    .kvl-chat-card {
                        width: 92vw;
                        max-width: 340px;
                        height: 78vh;
                        max-height: 520px;
                        bottom: 12px;
                        right: 12px;
                    }
                }
            `}</style>


            {!open && (
                <button
                    onClick={() => setOpen(true)}
                    aria-label="Open chat"
                    className="kvl-fab"
                >
                    <BsChatHeartFill size={28} color="#fff" />
                    {unread > 0 && (
                        <Badge
                            pill
                            bg="warning"
                            text="dark"
                            style={{
                                position: "absolute",
                                top: "-4px",
                                right: "-4px",
                                fontSize: "10.5px",
                                fontWeight: 700,
                                border: "2px solid #fff",
                            }}
                        >
                            {unread}
                        </Badge>
                    )}
                </button>
            )}


            {open && (
                <Card className="shadow-lg border-0 kvl-chat-card p-2" >

                    <div
                        className="d-flex justify-content-between align-items-center px-3 py-2"
                        style={{
                            background: "linear-gradient(90deg,#c2185b,#e91e63)",
                            color: "#fff",
                            flexShrink: 0,
                            borderTopLeftRadius: "15px",
                            borderTopRightRadius: "15px"
                        }}
                    >
                        <div className="d-flex align-items-center">
                            <div
                                className="rounded-circle bg-white me-2 d-flex align-items-center justify-content-center position-relative"
                                style={{ width: 38, height: 38, fontSize: 18, flexShrink: 0 }}
                            >
                                {BOT_AVATAR}
                                <span
                                    style={{
                                        position: "absolute",
                                        bottom: -1,
                                        right: -1,
                                        width: 10,
                                        height: 10,
                                        borderRadius: "50%",
                                        background: "#4caf50",
                                        border: "2px solid #fff",
                                    }}
                                />
                            </div>
                            <div>
                                <div style={{ fontWeight: 600, fontSize: "14px", lineHeight: 1.2 }}>
                                    Kalyani
                                </div>
                                <small style={{ opacity: 0.9, fontSize: "11px" }}>
                                    {isTyping ? (
                                        <span style={{ animation: "kvl-status-blink 1.2s infinite" }}>
                                            typing...
                                        </span>
                                    ) : (
                                        "Online • Replies instantly"
                                    )}
                                </small>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="border-0 bg-transparent text-white p-0"
                            onClick={() => setOpen(false)}
                            aria-label="Close chat"
                            style={{
                                fontSize: "24px",
                                opacity: 0.9,
                                cursor: "pointer",
                            }}
                        >
                            <IoClose />
                        </button>
                    </div>

                    <div className="p-3 kvl-scrollbar kvl-messages">
                        {messages.map((item, index) => (
                            <div
                                key={item.id || index}
                                className={`d-flex mb-3 ${item.type === "user"
                                    ? "justify-content-end"
                                    : "justify-content-start"
                                    }`}
                                style={{ animation: "kvl-msg-in .25s ease-out" }}
                            >
                                {item.type === "bot" && (
                                    <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0"
                                        style={{
                                            width: 28,
                                            height: 28,
                                            background: "#fce4ec",
                                            fontSize: 14,
                                        }}
                                    >
                                        {BOT_AVATAR}
                                    </div>
                                )}

                                <div style={{ maxWidth: "80%" }}>

                                    {/* Message Bubble */}
                                    {!(
                                        item.type === "bot" &&
                                        (
                                            (item.responseType === "profiles" && item.data?.profiles?.length > 0) ||
                                            (item.responseType === "plans" && item.data?.data?.length > 0) ||
                                            (item.responseType === "payment" && item.data?.payments?.length > 0) ||
                                            (item.responseType === "contacts" && item.data?.contacts) ||
                                            (item.responseType === "user" && item.data?.user)
                                        )
                                    ) && (
                                            <div
                                                style={{
                                                    background:
                                                        item.type === "user"
                                                            ? "linear-gradient(135deg,#d81b60,#e91e63)"
                                                            : "#fff",
                                                    color:
                                                        item.type === "user"
                                                            ? "#fff"
                                                            : "#333",
                                                    padding: "10px 14px",
                                                    borderRadius:
                                                        item.type === "user"
                                                            ? "15px 15px 5px 15px"
                                                            : "15px 15px 15px 5px",
                                                    fontSize: 13,
                                                    whiteSpace: "pre-wrap",
                                                }}
                                            >
                                                {item.text}
                                            </div>
                                        )}

                                    {renderResponse(item)}
                                    {(item.link || item.action) && (
                                        <button
                                            className="btn btn-sm mt-2"
                                            style={{
                                                background: "#d81b60",
                                                color: "#fff",
                                                borderRadius: 20,
                                            }}
                                            onClick={() => {
                                                if (item.action === "OPEN_LOGIN_MODAL") {
                                                    window.dispatchEvent(new CustomEvent("open-login-modal"));
                                                    return;
                                                }

                                                if (item.link) {
                                                    navigate(item.link);
                                                }
                                            }}
                                        >
                                            {item.buttonText || "Open"}
                                        </button>
                                    )}
                                </div>

                            </div>
                        ))}
                        {isTyping && (
                            <div className="d-flex mb-2 justify-content-start" style={{ animation: "kvl-msg-in 0.2s ease-out" }}>
                                <div
                                    className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0"
                                    style={{ width: 28, height: 28, background: "#fce4ec", fontSize: 14 }}
                                >
                                    {BOT_AVATAR}
                                </div>
                                <div
                                    className="d-flex align-items-center"
                                    style={{
                                        background: "#fff",
                                        borderRadius: "15px 15px 15px 4px",
                                        padding: "11px 15px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,.06)",
                                        gap: "4px",
                                    }}
                                >
                                    {[0, 1, 2].map((i) => (
                                        <span
                                            key={i}
                                            style={{
                                                width: 6,
                                                height: 6,
                                                borderRadius: "50%",
                                                background: "#d81b60",
                                                display: "inline-block",
                                                animation: `kvl-dot-bounce 1.1s ${i * 0.15}s infinite`,
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}

                        <div ref={messagesEndRef} />
                    </div>



                    <div className="p-2 px-3 border-top bg-white" style={{ flexShrink: 0 }}>
                        <InputGroup>
                            <Form.Control
                                ref={inputRef}
                                className="kvl-input"
                                placeholder="Type your message..."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") sendMessage();
                                }}
                                style={{
                                    borderRadius: "999px 0 0 999px",
                                    border: "1.5px solid #f0d0dc",
                                    fontSize: "13.5px",
                                    paddingLeft: "16px",
                                }}
                            />
                            <button
                                type="button"
                                className="kvl-send-btn"
                                onClick={sendMessage}
                                disabled={!message.trim()}
                                style={{
                                    background: "linear-gradient(135deg,#d81b60,#e91e63)",
                                    border: "none",
                                    borderRadius: "0 999px 999px 0",
                                    padding: "0 18px",
                                    fontSize: "18px",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: message.trim() ? "pointer" : "not-allowed",
                                }}
                            >
                                <IoSend />
                            </button>
                        </InputGroup>
                    </div>
                </Card>
            )}
        </>
    );
}